import axios from 'axios';

const instance = axios.create({
    // baseURL: 'https://pruebasmcm.gphsis.com/universidad/index.php/'
    baseURL: 'https://universidadmaderas.com/buniversity/index.php/'
});

export default instance;
